import "./types";
import { WORD_DIRECTIONS } from "./consts";

/**
 *
 * @param {Tile} t1
 * @param {Tile} t2
 * @returns {Direction} Relative direction from t1 to t2
 */
export function getDirectionFromTiles(t1, t2) {
  if (!t1 || !t2) return WORD_DIRECTIONS.NEUTRAL;
  const p1 = t1.position;
  const p2 = t2.position;

  if (p1.x > p2.x) {
    if (p1.y > p2.y) {
      return WORD_DIRECTIONS.NORTH_WEST;
    } else if (p1.y < p2.y) {
      return WORD_DIRECTIONS.SOUTH_WEST;
    } else {
      return WORD_DIRECTIONS.WEST;
    }
  } else if (p1.x < p2.x) {
    if (p1.y > p2.y) {
      return WORD_DIRECTIONS.NORTH_EAST;
    } else if (p1.y < p2.y) {
      return WORD_DIRECTIONS.SOUTH_EAST;
    } else {
      return WORD_DIRECTIONS.EAST;
    }
  }
  if (p1.y > p2.y) {
    return WORD_DIRECTIONS.NORTH;
  } else if (p1.y < p2.y) {
    return WORD_DIRECTIONS.SOUTH;
  } else {
    return WORD_DIRECTIONS.NEUTRAL;
  }
}
